module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_132845162446068.1180580a.jpg";